/**
 *  用户模块
 */
import http from '../assets/js/http'
// 部门列表
export const getDeptList = (params) => { return http.request({ url: '/user/department/getList', method: 'get', params: params }) }
// 部门列表
export const getDeptNames = (params) => { return http.request({ url: '/user/department/getBmmcs', method: 'get', params: params }) }
// 保存部门
export const saveDep = (params) => { return http.request({ url: '/user/department/save', method: 'get', params: params }) }
// 删除部门
export const removeDep = (params) => { return http.request({ url: '/user/department/removeDep', method: 'post', params: params }) }
// 岗位列表
export const getPostList = (params) => { return http.request({ url: '/user/post/getList', method: 'get', params: params }) }
// 保存岗位
export const savePost = (params) => { return http.request({ url: '/user/post/savePost', method: 'post', params: params }) }
// 删除岗位
export const removePost = (params) => { return http.request({ url: '/user/post/removePost', method: 'post', params: params }) }
// 用户列表
export const getList = (params) => { return http.request({ url: '/user/getList', method: 'get', params: params }) }
// 用户列表数据
export const getListData = (params) => { return http.request({ url: '/user/getListData', method: 'get', params: params }) }
// 保存用户
export const save = (params) => { return http.request({ url: '/user/save', method: 'post', params: params }) }
// 批量删除
export const removeall = (params) => { return http.request({ url: '/user/removeall', method: 'post', params: params }) }
// 删除
export const remove = (params) => { return http.request({ url: '/user/remove', method: 'post', params: params }) }
